module.exports = __webpack_public_path__ + "salesforce-logo-4ef6d1c70b5fde5cf3f6f3467a8504b1.svg";